

import Sorteos from "./sorteos"
import Participaciones from "./Participaciones"


const Index = ({dataInfo})=>{
    
    return(
        <div className="index">
            {dataInfo.data.dataUser && (
                <div className="card">
                    <h2>Bienvenido {dataInfo.data.dataUser.nombre}</h2>
                    <p>Su saldo disponible es de: <strong>${dataInfo.data.dataUser.saldo.toLocaleString('es-ES')}</strong></p>
                    {dataInfo.data.dataUser.vendedor && (
                        <p>total de referidos: {dataInfo.data.dataUser.referidos.length}</p>
                    )}
                </div>
                
            )}
            {dataInfo.data.dataSorteos && (
                <>
                {/* <Sorteos data={dataSorteos1} logo={dataEmpresa1.logoPeque} dataBoard={dataBoard} /> */}
                <Sorteos  dataInfo={dataInfo}/>
                <div className="card">
                    <h3>Participaciones Activas</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Sorteo</th>
                                <th>Numeros activos</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataInfo.data.dataSorteos.map((sorteo)=>{
                                return <Participaciones key={sorteo.id} data={{sorteo, uid:dataInfo.data.dataUser.uid}}/>                                
                            })}
                            {/* <Participaciones dataInfo={dataInfo} /> */}
                        </tbody>
                    </table>
                </div>
                </>
            )}

        </div>
    )
}
export default Index